import React from 'react'
import c from 'classnames'

import './Card.scss'

export default function Card(props) {
  let { hero, heroOverlay, content, footer, onClick, className } = props

  return (
    <div className={c('card', 'frikin-card', className)} onClick={onClick}>
      {hero && (
        <div className="card-hero">
          <figure
            className="image"
            style={{ backgroundImage: `url(${hero})` }}
          ></figure>
          {heroOverlay && <div className="hero-overlay">{heroOverlay}</div>}
          <figure
            className="image-inner"
            style={{ backgroundImage: `url(${hero})` }}
          ></figure>
        </div>
      )}
      {content && (
        <div className="card-content">
          <div className="content">{content}</div>
        </div>
      )}
      {footer && <footer className="card-footer">{footer}</footer>}
    </div>
  )
}
